export default __webpack_public_path__ + "static/media/Q10_0_resized.bc2ac4b1.jpg";